// The one channel order used by every report: Market Overview's Google page
// layout tiles, Advertiser Overview's channel tiles and the page tabs.
// From a result's serpMap (Google's UK page layout, top to bottom):
//   seen:       channels someone appeared in, in Google's page order
//   noneSeen:   channels AdAudit checks but nobody appeared in
//   notChecked: channels AdAudit doesn't collect yet (LSA, AI Overview), then
//               Bing - not part of Google's page, planned for later (Scott,
//               15 Oct 2026: show it now so the layout has room for it)
const COMING_LATER = ["bing"];

export function channelGroups(serpMap) {
  const blocks = serpMap || [];
  return {
    seen: blocks.filter(b => b.collected !== false && b.shownIn > 0).map(b => b.channel),
    noneSeen: blocks.filter(b => b.collected !== false && !(b.shownIn > 0)).map(b => b.channel),
    notChecked: [...blocks.filter(b => b.collected === false).map(b => b.channel), ...COMING_LATER],
  };
}
